import React from "react";
import { Container, SubTitle, Title } from "./styled.components";

const ProjectsHeader = () => {
  return (
    <Container>
      <Title>Projects</Title>
      <SubTitle>
        HHH and Sons Presents a Proud Past And Will Keep The Promise
        For Days To Come
      </SubTitle>
    </Container>
  );
};

export default ProjectsHeader;
